import axios from 'axios'
import APIConfig from '@/data/remote/APIConfig.js'
import moment from 'moment'

export default class TaskWorkingItemService {
    constructor() {
        this.lastFetchedAt = null // 2022-01-01 00:00:00+08:00 // moment().format('YYYY-MM-DD HH:mm:ssZ')
        this.apis = {
            getAll: (queryParams) => axios.get(APIConfig.APIURL + '/taskWorkingItem', { params: queryParams}),
            add: (payload) => axios.post(APIConfig.APIURL + '/taskWorkingItem', payload),
            edit: (id, payload) => axios.put(APIConfig.APIURL + `/taskWorkingItem/${id}`, payload),
            //inActivate: (id) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/inactivate`),
            delete: (id) => axios.delete(APIConfig.APIURL + `/taskWorkingItem/${id}`),
            // custom
            // reject: (id, payload) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/reject`, payload),
            rejectBonus: (id, payload) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/rejectBonus`, payload),
            rejectReport: (id, payload) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/rejectReport`, payload),
            rejectArrange: (id, payload) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/rejectArrange`, payload),
            rejectCheckBonus: (id, payload) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/rejectCheckBonus`, payload), // 員工退回主管通過的日誌
            checkOK: (id) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/checkOK`), // 員工確認主管通過的日誌
            report: (id, payload) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/report`, payload),
            verify: (id, payload) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/verify`, payload),
            submit: (id, payload) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/submit`, payload),
            sign: (id) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/sign`),
            submitSelf: (id, payload) => axios.post(APIConfig.APIURL + `/taskWorkingItem/${id}/submitSelf`, payload),
        }
    }

    prepareData(vm) {
        return new Promise((resolve, reject) => {
            if (vm.$store.state.taskWorkingItem.isFetched) {
                resolve(vm.$store.state.taskWorkingItem.list)
                return
            }
            if (vm.$store.state.taskWorkingItem.isFetching) {
                var timer = setInterval(() => {
                    if (vm.$store.state.taskWorkingItem.isFetching) return
                    clearInterval(timer)
                    if (vm.$store.state.taskWorkingItem.isFetched) {
                        resolve(vm.$store.state.taskWorkingItem.list)
                    } else {
                        reject('無法取得資料，請嘗試重新整理')
                    }
                }, 500)
                return
            }
            vm.$store.state.taskWorkingItem.isFetching = true
            let queryParams = null
            if (this.lastFetchedAt) {
                queryParams = {from: this.lastFetchedAt}
            }
            return this.getAll(vm, queryParams)
                .then(res => {
                    vm.$store.state.taskWorkingItem.isFetched = true
                    vm.$store.state.taskWorkingItem.isReloaded = false
                    let dataList = res.data.result || []
                    if (!vm.$store.state.taskWorkingItem.list || !vm.$store.state.taskWorkingItem.list.length) {
                        vm.$store.state.taskWorkingItem.list = dataList
                    } else {
                        for(let data of dataList) {
                            let idx = vm.$store.state.taskWorkingItem.list.findIndex(o=>o.ID == data.ID)
                            if (idx >= 0) {
                                vm.$set(vm.$store.state.taskWorkingItem.list, idx, data)
                            } else {
                                vm.$store.state.taskWorkingItem.list.push(data)
                            }
                        }
                    }
                    return res
                })
                .then(res => {
                    this.lastFetchedAt = moment().format('YYYY-MM-DD HH:mm:ssZ')
                    vm.$store.state.taskWorkingItem.isFetching = false
                    resolve()
                    return res
                })
                .catch(err => {
                    vm.$store.state.taskWorkingItem.isFetching = false
                    reject(err)
                })
        })
    }

    getAll(vm, queryParams) {
        return new Promise((resolve, reject) => {
            this.apis.getAll(queryParams)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    add(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.add(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    edit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.edit(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    inActivate(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.inActivate(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    delete(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.delete(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    report(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.report(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    rejectBonus(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.rejectBonus(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    rejectReport(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.rejectReport(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    rejectArrange(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.rejectArrange(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    // rejectCheckBonus 員工退回主管通過的日誌
    rejectCheckBonus(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.rejectCheckBonus(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    // checkOK 員工確認主管通過的日誌
    checkOK(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.checkOK(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    verify(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.verify(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    submit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.submit(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    submitSelf(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.submitSelf(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    sign(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.sign(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }
}
